<div class="flex flex-col p-2.5">
  <span>Sin stock de:</span>

  <li *ngFor="let element of cartService.exceededBindingItems(group.product.printingGroup)">
    {{ element }}
  </li>
</div>
